// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import AppointmentController from "./appointment_controller";
application.register("appointment", AppointmentController);

import AutoSubmitController from "./auto_submit_controller";
application.register("auto-submit", AutoSubmitController);

import AppointmentsController from "./appointments_controller";
application.register("appointments", AppointmentsController);

import CategoryComboboxController from "./category_combobox_controller";
application.register("category-combobox", CategoryComboboxController);

import SortableController from "./sortable_controller";
application.register("sortable", SortableController);

import ClipboardController from "./clipboard_controller";
application.register("clipboard", ClipboardController);

import DateRangeController from "./date_range_controller";
application.register("date-range", DateRangeController);

import DropdownController from "./dropdown_controller";
application.register("dropdown", DropdownController);

import FlashController from "./flash_controller";
application.register("flash", FlashController);

import FormSelectController from "./form_select_controller";
application.register("form-select", FormSelectController);

import FormValidationController from "./form_validation_controller";
application.register("form-validation", FormValidationController);

import LiveTimeController from "./live_time_controller";
application.register("live-time", LiveTimeController);

import ModalController from "./modal_controller";
application.register("modal", ModalController);

import OperationsLayoutController from "./operations_layout_controller";
application.register("operations-layout", OperationsLayoutController);

import PhotoUploadController from "./photo_upload_controller";
application.register("photo-upload", PhotoUploadController);

import QuickBookingController from "./quick_booking_controller";
application.register("quick-booking", QuickBookingController);

import ScheduleModalFormController from "./schedule_modal_form_controller";
application.register("schedule-modal-form", ScheduleModalFormController);

import SchedulePreviewController from "./schedule_preview_controller";
application.register("schedule-preview", SchedulePreviewController);

import ServiceAssignmentController from "./service_assignment_controller";
application.register("service-assignment", ServiceAssignmentController);

import StaffStatusController from "./staff_status_controller";
application.register("staff-status", StaffStatusController);

import ToastController from "./toast_controller";
application.register("toast", ToastController);

import OperationsScheduleController from "./operations_schedule_controller";
application.register("operations-schedule", OperationsScheduleController);

import SchedulerPlaygroundController from "./scheduler_playground_controller";
application.register("scheduler-playground", SchedulerPlaygroundController);

import CalendarEventLogController from "./calendar_event_log_controller";
application.register("calendar-event-log", CalendarEventLogController);

import ShareController from "./share_controller";
application.register("share", ShareController);

import TiptapController from "./tiptap_controller";
application.register("tiptap", TiptapController);

import CollapsibleController from "./collapsible_controller";
application.register("collapsible", CollapsibleController);

import RemoveController from "./remove_controller";
application.register("remove", RemoveController);

import AllDayToggleController from "./all_day_toggle_controller";
application.register("all-day-toggle", AllDayToggleController);

import VerificationCodeController from "./verification_code_controller";
application.register("verification-code", VerificationCodeController);

import CoverPhotoController from "./cover_photo_controller";
application.register("cover-photo", CoverPhotoController);

import ImageCropperController from "./image_cropper_controller";
application.register("image-cropper", ImageCropperController);

import ToggleDescriptionController from "./toggle_description_controller";
application.register("toggle-description", ToggleDescriptionController);

import StarRatingController from "./star_rating_controller";
application.register("star-rating", StarRatingController);

import CharacterCountController from "./character_count_controller";
application.register("character-count", CharacterCountController);

import LocationPickerController from "./location_picker_controller";
application.register("location-picker", LocationPickerController);

import BusinessHoursEditorController from "./business_hours_editor_controller";
application.register("business-hours-editor", BusinessHoursEditorController);

import SignupFormController from "./signup_form_controller";
application.register("signup-form", SignupFormController);

import LandingController from "./landing_controller";
application.register("landing", LandingController);

import QuickClientComboboxController from "./quick_client_combobox_controller";
application.register("quick-client-combobox", QuickClientComboboxController);

import QuickServiceComboboxController from "./quick_service_combobox_controller";
application.register("quick-service-combobox", QuickServiceComboboxController);

import QuickStaffComboboxController from "./quick_staff_combobox_controller";
application.register("quick-staff-combobox", QuickStaffComboboxController);

import ScheduleFiltersController from "./schedule_filters_controller";
application.register("schedule-filters", ScheduleFiltersController);
